import { create } from 'zustand';
import { FetchError } from './fetcher';
var useApiErrorStore = create(function (set, get) { return ({
    state: {
        apiError: undefined,
        apiErrorCode: undefined,
    },
    actions: {
        getApiErrorCode: function () {
            var error = get().state.apiError;
            return error ? generateApiErrorCode(error) : undefined;
        },
        setApiError: function (apiError) {
            set(function () { return ({
                state: { apiError: apiError },
            }); });
        },
        clearApiError: function () {
            set(function () { return ({ state: { apiError: undefined, apiErrorCode: undefined } }); });
        },
    },
}); });
export var useApiErrorStoreState = function () { return useApiErrorStore(function (state) { return state.state; }); };
export var useApiErrorStoreActions = function () { return useApiErrorStore(function (state) { return state.actions; }); };
var generateApiErrorCode = function (apiError) {
    var fetchError = FetchError.getFetchError(apiError.error);
    return (fetchError === null || fetchError === void 0 ? void 0 : fetchError.status) ? "".concat(apiError.apiPathId).concat(fetchError.status) : undefined;
};
